var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampaigns(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8.75V11.25H25V8.75H20ZM17.5 17.0125C18.7 17.9 20.2625 19.075 21.5 20C22 19.3375 22.5 18.6625 23 18C21.7625 17.075 20.2 15.9 19 15C18.5 15.675 18 16.35 17.5 17.0125ZM23 2C22.5 1.3375 22 0.6625 21.5 0C20.2625 0.925 18.7 2.1 17.5 3C18 3.6625 18.5 4.3375 19 5C20.2 4.1 21.7625 2.9375 23 2ZM2.5 6.25C1.125 6.25 0 7.375 0 8.75V11.25C0 12.625 1.125 13.75 2.5 13.75H3.75V18.75H6.25V13.75H7.5L13.75 17.5V2.5L7.5 6.25H2.5ZM8.7875 8.3875L11.25 6.9125V13.0875L8.7875 11.6125L8.1875 11.25H2.5V8.75H8.1875L8.7875 8.3875ZM16.875 10C16.875 8.3375 16.15 6.8375 15 5.8125V14.175C16.15 13.1625 16.875 11.6625 16.875 10Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaigns);
export default __webpack_public_path__ + "static/media/campaigns.bcd3875440c826155aeabc2a426ef60b.svg";
export { ForwardRef as ReactComponent };